import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router';
import { useEvent } from '../../../data/hooks/eventHooks';
import { useI18n } from '../../../data/hooks/i18nHooks';
import WaitWhileBusy from '../../WaitWhileBusy';
import Scrollable from '../../elements/Scrollable';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import LoadProgram from '../../loaders/LoadProgram';
import Screen from '../Screen';
import styles from './StartNetworking.module.scss';
import ChatGroup from './groups/ChatGroup/ChatGroup';
import FavoriteGroup from './groups/FavoriteGroup/FavoriteGroup';
import FindGroup from './groups/FindGroup';
import GetFoundGroup from './groups/GetFoundGroup';
import QuestsGroup from './groups/QuestsGroup';
import ScheduleGroup from './groups/ScheduleGroup/ScheduleGroup';

const StartNetworking = props => {
    const {eventId} = useParams(),
        event = useEvent(eventId),
        i18n = useI18n(),
        wrapperRef = useRef(),
        [timelineHeight, setTimelineHeight] = React.useState(0);

    useEffect(() => {
        if (wrapperRef.current) {
            setTimelineHeight(wrapperRef.current.clientHeight);
        }
    });

    const header = (
        <div className={styles.header}>
            <TopBarEvent event={event} returnURL="..">
                {i18n['start.header']}
            </TopBarEvent>
            <hr />
            <div className={styles.description}>
                <p>{i18n['start.intro']}</p>
            </div>
        </div>
    );

    return (
        <Screen className={styles.StartNetworking} header={header}>
            <Scrollable>
                <div className={['zebra', styles.wrapper].join(' ')} ref={wrapperRef}>
                    <GetFoundGroup eventId={eventId} />
                    <FindGroup eventId={eventId} />
                    <QuestsGroup eventId={eventId} />
                    <ScheduleGroup eventId={eventId} />
                    <FavoriteGroup eventId={eventId} />
                    <ChatGroup eventId={eventId} />
                    <div className={styles.timeline} style={{height: timelineHeight}} />
                </div>
            </Scrollable>
        </Screen>
    );
};

export default props => {
    const {eventId} = useParams();
    return (
        <LoadProgram eventId={eventId}>
            <WaitWhileBusy>
                <StartNetworking />
            </WaitWhileBusy>
        </LoadProgram>
    );
};
